import { defineCopy } from "@tami/core/intl";

import { LOADING_INDICATOR_COPY_EN_US } from "./en-us/loading-indicator.copy";
import { LOADING_INDICATOR_COPY_ES_ES } from "./es-es/loading-indicator.copy";

/** Textos do indicador de carregamento. */
export const LOADING_INDICATOR_COPY_PT_BR = {
  loading: "Carregando",
} as const;

export const LOADING_INDICATOR_COPY = defineCopy(LOADING_INDICATOR_COPY_PT_BR, {
  "en-US": LOADING_INDICATOR_COPY_EN_US,
  "es-ES": LOADING_INDICATOR_COPY_ES_ES,
});
